import React, { useState } from "react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LockIcon from "@material-ui/icons/Lock";
import { useDispatch, useSelector } from "react-redux";
import colors from "../styles/colors";
import {
  Avatar,
  Button,
  Card,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { Redirect } from "react-router";
import { useHistory } from "react-router-dom";
import { isUserAuthenticated, logInUser } from "../redux/slices/userSlice";
import { handleNotificationMessage } from "../utils/notifications";

const LogInPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const isAuthenticated = useSelector((state) => isUserAuthenticated(state));

  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    dispatch(logInUser({ data })).then((payload) => {
      setLoading(false);
      if (payload && payload.error) {
        handleNotificationMessage("login", null, payload.error, "error");
        return;
      }
      history.push("/admin/search");
    });
  };

  return isAuthenticated ? (
    <Redirect to="/admin/search" />
  ) : (
    <Grid
      style={{ height: "100%" }}
      justifyContent="center"
      alignItems="center"
      container
    >
      <Grid item>
        <Card elevate={10} style={{ padding: "3%", margin: "3%" }}>
          <form
            onChange={(e) =>
              setData({ ...data, [e.target.name]: e.target.value })
            }
            name="normal_login"
            className="login-form"
          >
            <Avatar />
            <Typography size="20px">Log in here</Typography>
            <TextField
              id="username"
              name="username"
              value={data.username}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircleIcon />
                  </InputAdornment>
                ),
              }}
              placeholder="Username"
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              id="password"
              name="password"
              value={data.password}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              }}
              type="password"
              placeholder="Password"
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Password"
              autoComplete="current-password"
            />
            <Button
              style={{ width: "100%", backgroundColor: colors.red }}
              type="primary"
              danger="true"
              className="login-form-button"
              onClick={onSubmit}
              loading={+loading}
            >
              Log in
            </Button>
          </form>
        </Card>
      </Grid>
    </Grid>
  );
};

export default LogInPage;
